// ~/plugins/emitter.ts
import {defineNuxtPlugin} from '#app';
import mitt from 'mitt';

type ApplicationEvents = {
  'fields:save': undefined
  'accountingLines:save': undefined
  'flow:updated': undefined
  'navigate:next_document': undefined
  'navigate:back_to_document_list': undefined
  'flow:edit': undefined
  'new-automation-block:deleted': string,
  'automations:open-add-block': string
}

export type EventEmit = <K extends keyof ApplicationEvents>(
  type: K,
  ...args: ApplicationEvents[K] extends undefined ? [] : [payload: ApplicationEvents[K]]
) => void

export type EventListen = <K extends keyof ApplicationEvents>(
  type: K,
  handler: (...args: ApplicationEvents[K] extends undefined ? [] : [payload: ApplicationEvents[K]]) => void
) => void

export default defineNuxtPlugin(() => {
  const emitter = mitt<ApplicationEvents>();

  return {
    provide: {
      event: emitter.emit as EventEmit,
      listen: emitter.on as EventListen
    }
  };
});